import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import styles from './profile-dashboard-hero-section.module.scss';
export type ProfileDashboardHeroSectionProps = {
  badgeSlot?: null | ReactElement;
  companyAdminSlot?: ReactElement;
  profilePhotoSlot: ReactElement;
  profileSummaryActionsSlot: ReactElement;
  profileSummarySlot: ReactElement;
};
export const ProfileDashboardHeroSection = t0 => {
  const $ = _c(10);
  const {
    badgeSlot,
    companyAdminSlot,
    profilePhotoSlot,
    profileSummaryActionsSlot,
    profileSummarySlot
  } = t0;
  let t1;
  if ($[0] !== companyAdminSlot || $[1] !== profileSummaryActionsSlot || $[2] !== profileSummarySlot) {
    t1 = <div className={styles["hero-section__summary-container"]} data-testid="profile-container">{profileSummarySlot}{profileSummaryActionsSlot}{companyAdminSlot}</div>;
    $[0] = companyAdminSlot;
    $[1] = profileSummaryActionsSlot;
    $[2] = profileSummarySlot;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== badgeSlot) {
    t2 = badgeSlot && <div className={styles["hero-section__badge-container"]}>{badgeSlot}</div>;
    $[4] = badgeSlot;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== profilePhotoSlot || $[7] !== t1 || $[8] !== t2) {
    t3 = <div className={styles["hero-section"]} data-testid="hero-section-content">{profilePhotoSlot}{t1}{t2}</div>;
    $[6] = profilePhotoSlot;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};